import React, { useState, useRef } from 'react';
import './VideoIntroOverlay.css';

const DEFAULT_VIDEO_SRC = '/videos/banner-intro.mp4';

function VideoIntroOverlay({ onDismiss, videoSrc }) {
  const [hidden, setHidden] = useState(false);
  const [dustClearing, setDustClearing] = useState(false);
  const videoRef = useRef(null);
  const src = (videoSrc && videoSrc.trim()) || DEFAULT_VIDEO_SRC;

  const startDismiss = () => {
    if (videoRef.current) videoRef.current.pause();
    setDustClearing(true); // dust fades out first (video "removed" the dust)
    setTimeout(() => {
      setHidden(true);
      setTimeout(onDismiss, 350);
    }, 600);
  };

  const handleEnded = () => startDismiss();
  const handleSkip = () => startDismiss();

  const handleCanPlay = () => {
    if (videoRef.current) videoRef.current.play().catch(() => {});
  };

  return (
    <div className={`video-intro-overlay ${hidden ? 'video-intro-overlay--hidden' : ''}`}>
      <div
        className={`video-intro-overlay__dusty-bg ${dustClearing ? 'video-intro-overlay__dusty-bg--clearing' : ''}`}
        aria-hidden="true"
      />
      <div className="video-intro-overlay__video-wrap">
        <video
          ref={videoRef}
          className="video-intro-overlay__video"
          src={src}
          muted
          playsInline
          onEnded={handleEnded}
          onCanPlayThrough={handleCanPlay}
        />
      </div>
      <button
        type="button"
        className="video-intro-overlay__skip"
        onClick={handleSkip}
        aria-label="Skip intro"
      >
        Skip
      </button>
    </div>
  );
}

export default VideoIntroOverlay;
